export default __webpack_public_path__ + "static/media/gmail-icon.e24234f5.svg";